<template>
  <b-card class="no-border mt-3" no-body>
    <vehicle-group-table />
  </b-card>
</template>
<script>
import VehicleGroupTable from '@/components/VehicleGroupTable.vue';

export default {
  name: 'vehicle_group_list',
  components: {
    VehicleGroupTable,
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'vehicles', name: 'Vehicles' },
    ]);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/vehicle_group/List.vue